// extracted by mini-css-extract-plugin
export default {"headerWraper":"navbar_headerWraper__pMNNy","header":"navbar_header__bTJNj"};